import { lazy } from "react";
const BaseLayoutId = lazy(() => import("src/views/arkadu/BaseLayoutId"));

export default [
  {
    exact: true,
    path: "/:customerName/dinvoice/create",
    component: lazy(() =>
      import("src/views/arkadu/dinvoice/CreateLegalDocument"),
    ),
  },
  {
    exact: true,
    layout: BaseLayoutId,
    path: "/:customerName/dinvoice/detail/:id",
    component: lazy(() =>
      import("src/views/arkadu/dinvoice/LegalDocumentDetail"),
    ),
  },
  {
    exact: true,
    path: ["/:customerName/dinvoice/", "/:customerName/dinvoice/:tabName"],
    component: lazy(() => import("src/views/arkadu/dinvoice/DinvoiceIndex")),
  },
];
